/**
 * BrokerListItem Component
 *
 * Reusable list item for displaying a broker in list views.
 * Used by MobileBrokerList page.
 *
 * Pattern follows AccountListItem (Card-based, isPressable/isHoverable).
 */

// 1. External dependencies
import React from 'react';
import { Package } from 'lucide-react';

// 2. Workspace packages
import { Card, CardBody } from '@enfomentis/ui';

// 3. Internal absolute imports
import type { Broker } from '@/types/schema/Broker';

interface BrokerListItemProps {
  broker: Broker;
  onSelect: () => void;
}

export const BrokerListItem: React.FC<BrokerListItemProps> = ({
  broker,
  onSelect,
}) => {
  return (
    <Card
      isPressable
      isHoverable
      onPress={onSelect}
      className="w-full border-1 border-default-200 hover:border-default-300"
      radius="sm"
      shadow="none"
    >
      <CardBody className="py-3 px-4">
        <div className="flex items-center justify-between">

          <span className="font-medium text-text-primary truncate">
            {broker.name}
          </span>
          <div className="flex items-center gap-2 min-w-0">
            {broker.status === 'archived' && (
              <span className="text-xs text-text-tertiary shrink-0 ml-2">Archived</span>
            )}
            {broker.brokerReferenceId && (
              <Package size={14} className="text-text-tertiary shrink-0" />
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};
